import { render, staticRenderFns } from "./ServiceStatusWidget.vue?vue&type=template&id=5087fa63"
import script from "./ServiceStatusWidget.vue?vue&type=script&lang=js"
export * from "./ServiceStatusWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports